/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy tools to dominate your league. Apex Team optimizer, Budget Builder price predictions, live standings, and full driver & constructor statistics.`)
};

const es_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de F1 Fantasy para dominar tu liga. Optimizador de Equipo Apex, predicciones de precios del Budget Builder, clasificación en vivo y estadísticas completas de pilotos y constructores.`)
};

const de_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy Werkzeuge zur Dominanz in deiner Liga. Apex-Team Optimierer, Budget Builder Preisprognosen, Live-Tabellen und vollständige Fahrer- und Konstrukteurstatistiken.`)
};

const nl_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy tools om je competitie te domineren. Apex Team optimizer, Budget Builder prijsvoorspellingen, live klassement en volledige coureurs- en constructeursstatistieken.`)
};

const fr_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des outils F1 Fantasy pour dominer votre ligue. Optimiseur Équipe Apex, prédictions de prix Boost Budget, classements en direct et statistiques complètes des pilotes et constructeurs.`)
};

const it_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti F1 Fantasy per dominare la tua lega. Ottimizzatore Team Apex, previsioni prezzi Budget Builder, classifiche live e statistiche complete di piloti e costruttori.`)
};

const pt_br2_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas F1 Fantasy para dominar sua liga. Otimizador Equipe Apex, previsões de preço do Budget Builder, classificações ao vivo e estatísticas completas de pilotos e construtores.`)
};

const pt_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas F1 Fantasy para dominar a sua liga. Otimizador Equipa Apex, previsões de preços Impulso de Orçamento, classificações em direto e estatísticas completas de pilotos e construtores.`)
};

const ja_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リーグを制するF1ファンタジーツール。Apexチーム最適化、Budget Builderの価格予測、ライブ順位表、ドライバー＆コンストラクターの詳細統計。`)
};

const zh_tool_f1_fantasy_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1梦幻赛车工具，助您称霸联赛。Apex车队优化器、Budget Builder价格预测、实时积分榜及车手与车队完整统计数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tool_f1_fantasy_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tool_f1_fantasy_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tool_f1_fantasy_description", locale)
	if (locale === "en") return en_tool_f1_fantasy_description(inputs)
	if (locale === "es") return es_tool_f1_fantasy_description(inputs)
	if (locale === "de") return de_tool_f1_fantasy_description(inputs)
	if (locale === "nl") return nl_tool_f1_fantasy_description(inputs)
	if (locale === "fr") return fr_tool_f1_fantasy_description(inputs)
	if (locale === "it") return it_tool_f1_fantasy_description(inputs)
	if (locale === "pt-BR") return pt_br2_tool_f1_fantasy_description(inputs)
	if (locale === "pt") return pt_tool_f1_fantasy_description(inputs)
	if (locale === "ja") return ja_tool_f1_fantasy_description(inputs)
	return zh_tool_f1_fantasy_description(inputs)
};